import { Base } from 'zf-web-components';
import { useContext, useRef } from 'react';
import { ThemeService } from '@services';
import { RootContext } from '@stores';
import type { AppResult } from './types';

/**
 * 获取当前应用
 */
export function useApp(): AppResult {
  const { local } = useContext(RootContext);
  const { current: service } = useRef(new ThemeService(local));

  const dark = false;
  const app = service.getApp();
  const name = service.getAppName(app);
  const colorPrimary = service.getPrimaryColor(app);
  const logo = service.getLogo(app);

  /**
   * Antd 主题配置
   */
  const theme: Base.ThemeConfig = {
    algorithm: dark ? Base.theme.darkAlgorithm : Base.theme.defaultAlgorithm,
    hashed: false,
    token: {
      colorPrimary,
      fontSize: 12,
      borderRadius: 4,
      colorTextBase: dark ? '#ffffff' : '#000000',
      fontFamily: service.getFontFamily().join(',')
    },
    components: {
      Card: {
        paddingLG: 12
      },
      Menu: {
        itemColor: '#6C757D',
        fontSize: 14,
        subMenuItemBg: '#ffffff' // 子菜单背景色，默认是浅灰色改为白色
      },
      Radio: {
        buttonSolidCheckedBg: colorPrimary,
        buttonSolidCheckedHoverBg: colorPrimary
      },
      Segmented: {
        itemSelectedColor: colorPrimary
      },
      Skeleton: {
        gradientFromColor: 'rgba(0,0,0,0.04)',
        gradientToColor: 'rgba(0,0,0,0.10)'
      }
    }
  };

  return { app, name, logo, theme, colorPrimary };
}
